import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import BoArt from './BoArt';

/**
 * FAQ: static panels, not an accordion. Every answer here must agree with
 * the privacy policy and the terms it links to - a marketing claim that
 * outlives the policy is how a privacy policy ends up the only honest page.
 */
const FAQ = () => (
  <section id="faq" className="section section-deep" aria-labelledby="faq-headline">
    <div className="section-inner">
      <Reveal>
        <div className="faq-head">
          <div>
            <p className="eyebrow">FAQ</p>
            <h2 id="faq-headline" className="h2">
              Straight answers.
            </h2>
          </div>
          <BoArt pose="rest" width={120} className="faq-bo" />
        </div>
        <div className="grid-2 faq">
          <div className="card">
            <h3 className="h3">Is kettlebell training safe for me?</h3>
            <p>
              Bell Club is not medical advice. If you are new to exercise, pregnant, injured or have
              a medical condition, talk to a doctor or a qualified professional first. Then start
              light - lighter than you think - and add weight only when your technique holds. Stop
              if anything hurts. The <Link to="/terms-of-service#health-and-safety">terms</Link> say
              more.
            </p>
          </div>
          <div className="card">
            <h3 className="h3">Do I need two kettlebells?</h3>
            <p>
              No. Every program works with one bell. If you own more than one, each move is set for
              the bell that suits it, and Full Body Strength can use two at once.
            </p>
          </div>
          <div className="card">
            <h3 className="h3">Is there a feed?</h3>
            <p>
              No. There is no public feed, no followers and no chat. You see your crew - at most
              twelve people, joined by invites that expire - and they see you: finished sessions,
              check-ins like “Rest day”, records you choose to share, and reactions.
            </p>
          </div>
          <div className="card">
            <h3 className="h3">Who sees my heart rate?</h3>
            <p>
              Nobody. Heart rate and energy stay on your devices and in Apple Health. They are never
              sent to us or to your crew, even when your log syncs, and never shown in a
              notification. The <Link to="/privacy-policy#apple-health">privacy policy</Link> has
              the details.
            </p>
          </div>
          <div className="card">
            <h3 className="h3">Do I need an account?</h3>
            <p>
              Not to train: your plan and your log live on your phone. Sign in and your workout log
              is also kept on your account - private to you - so a new or reset phone gets it back.
              Crews need an account too. Heart rate and other Apple Health data are never uploaded.
            </p>
          </div>
          <div className="card">
            <h3 className="h3">Who is it for?</h3>
            <p>
              Adults - you need to be 18 or over. Bell Club is for people training at home with one
              or two kettlebells, two to four times a week.
            </p>
          </div>
          <div className="card">
            <h3 className="h3">What do I need? Android?</h3>
            <p>
              An iPhone with iOS 27 or later. The Apple Watch app is optional and needs watchOS 27
              or later. Android: not yet.
            </p>
          </div>
          <div className="card">
            <h3 className="h3">How do I pay, and cancel?</h3>
            <p>
              Bell Club Pro is an in-app purchase through the App Store - there is no checkout on
              this website. Manage or cancel it any time in your iPhone's Settings → Apple Account →
              Subscriptions.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
